{#if show}
  <BaseDialog lg modal
    bind:show={show}
    {title}>
  <!-- <div>Esto es una prueba</div> -->
  <Panel>
    <TicketTemplateEditor recordDef={recordDef} template={template} onDone={onDone} />
  </Panel>

  </BaseDialog>
{/if}

<script>
  import { Panel } from 'svelte-stylo'
  import BaseDialog from '@/components/dialogs/BaseDialog.svelte'
  import TicketTemplateEditor from './template-editor/TicketTemplateEditor.svelte'

  let
    show = false,
    recordDef = {},
    template = {},
    onDone = null
  
  const title = 'Generar Plantilla'
  
  window.RecordDefTicketTemplateDialog = function () {
    /** 
     * Set this as a global object so we can call it from anywhere
     * for example from the Mediator 
     */
    return {
      open: function(receivedTemplate, callback) {
        if (receivedTemplate) {
          template = JSON.parse(receivedTemplate)
        }
        recordDef = theModel.get("record_def_props")
        onDone = callback
        show = true
      },
      close: function() {
        show = false
      }
    }
  }

</script>